import type { ServerMetadata } from "@app/lib/actions/mcp_internal_actions/tool_definition";
import { createToolsRecord } from "@app/lib/actions/mcp_internal_actions/tool_definition";
import {
  MAX_BROWSE_URLS,
  WebbrowseInputSchema,
  WebsearchInputSchema,
} from "@app/lib/actions/mcp_internal_actions/types";
import type { JSONSchema7 as JSONSchema } from "json-schema";
import { z } from "zod";
import { zodToJsonSchema } from "zod-to-json-schema";

export const WEB_SEARCH_BROWSE_SERVER_NAME = "web_search_&_browse" as const;
export const WEB_SEARCH_BROWSE_ACTION_DESCRIPTION =
  "Agent can search (Google) and retrieve information from specific websites.";

export const WEB_SEARCH_BROWSE_TOOLS_METADATA = createToolsRecord({
  websearch: {
    description:
      "A tool that performs a Google web search based on a string query.",
    schema: WebsearchInputSchema.shape,
    stake: "never_ask",
    enableAlerting: true,
    displayLabels: {
      running: "Searching the web",
      done: "Web search",
    },
  },
  webbrowser: {
    description: `A tool to browse websites, you can provide a list of up to ${MAX_BROWSE_URLS} urls to browse all at once.`,
    schema: WebbrowseInputSchema.shape,
    stake: "never_ask",
    enableAlerting: true,
    displayLabels: {
      running: "Browsing web page",
      done: "Browse web page",
    },
  },
});

export const WEB_SEARCH_BROWSE_SERVER = {
  serverInfo: {
    name: WEB_SEARCH_BROWSE_SERVER_NAME,
    version: "1.0.0",
    description: WEB_SEARCH_BROWSE_ACTION_DESCRIPTION,
    authorization: null,
    icon: "ActionGlobeAltIcon" as const,
    documentationUrl: null,
  },
  tools: Object.values(WEB_SEARCH_BROWSE_TOOLS_METADATA).map((t) => ({
    name: t.name,
    description: t.description,
    inputSchema: zodToJsonSchema(z.object(t.schema)) as JSONSchema,
    displayLabels: t.displayLabels,
  })),
  tools_stakes: Object.fromEntries(
    Object.values(WEB_SEARCH_BROWSE_TOOLS_METADATA).map((t) => [
      t.name,
      t.stake,
    ])
  ),
} as const satisfies ServerMetadata;
